var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiTsPayrollCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24,14.495v.505h-1v-.505c0-.824-.671-1.495-1.495-1.495h-3.01c-.824,0-1.495.671-1.495,1.495,0,.664.446,1.255,1.084,1.438l4.106,1.174c1.065.304,1.81,1.29,1.81,2.398,0,1.376-1.119,2.495-2.495,2.495h-1.005v2h-1v-2h-1.005c-1.376,0-2.495-1.119-2.495-2.495v-.505h1v.505c0,.824.671,1.495,1.495,1.495h3.01c.824,0,1.495-.671,1.495-1.495,0-.664-.446-1.255-1.084-1.438l-4.106-1.174c-1.065-.304-1.81-1.29-1.81-2.398,0-1.376,1.119-2.495,2.495-2.495h1.005v-2h1v2h1.005c1.376,0,2.495,1.119,2.495,2.495Zm0-9.995v4.5H1v14h14.704c.769.616,1.732,1,2.792,1H0V4.5c0-1.379,1.121-2.5,2.5-2.5h3.5V0h1v2h10V0h1v2h3.5c1.379,0,2.5,1.121,2.5,2.5Zm-1,0c0-.827-.673-1.5-1.5-1.5H2.5c-.827,0-1.5.673-1.5,1.5v3.5h22v-3.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiTsPayrollCalendar);
export default __webpack_public_path__ + "static/media/fi-ts-payroll-calendar.cd1eb542799b9954387d1c33c8115a07.svg";
export { ForwardRef as ReactComponent };